
import Simcard from "../../../assets/filled/Simcard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SimcardIcon({ className, dataTestid = "SimcardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Simcard data-testid={dataTestid} className={classes} {...rest} />
  );
}
